import { defineComponent as _defineComponent } from 'vue'
import InspirationalContentViewObject = Vertica.LouisPoulsen.Application.Content.Blocks.InspirationalContentViewObject;
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspirationalContent',
  props: {
    contentItems: { default: () => [] },
    showMoreImagesLabel: { default: 'Show more images' },
    showLessImagesLabel: { default: 'Show less images' },
    showTitles: { type: Boolean, default: true },
    showAllContent: { type: Boolean },
    clickOpensModal: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { contentItems: InspirationalContentViewObject[], showMoreImagesLabel: string, showLessImagesLabel: string, showTitles: boolean, showAllContent?: boolean, clickOpensModal?: boolean }



const breakpoints = useBreakpoints();

const uid = Math.floor(Math.random() * 1000000);
const zoomModalToggled = ref<boolean>(false);
const selectedZoomIndex = ref<number>(0);
const imageAmountThreshold = 2;

const showMore = ref<boolean>(false);

const inView = ref<{[index: number]: boolean}>({});
const classPrefix = ref<string>('inspirational-content-');
const allContentIsShown = ref<boolean>(false);

onMounted(() => {
    classPrefix.value += uid + '-';
    allContentIsShown.value = props.contentItems.length <= imageAmountThreshold || props.showAllContent;
    showMore.value = allContentIsShown.value;
    for (let i = 0; i < props.contentItems.length; i++) {
        inView.value[i] = allContentIsShown.value || i < imageAmountThreshold;
    }
});

function clickAction(contentObjectIndex) {
    if (props.clickOpensModal) {
        toggleZoomModal(contentObjectIndex);
    }
}

function allowView(contentObjectIndex) {
    if (contentObjectIndex < props.contentItems.length - 1) {
        const newInView = Object.assign({}, inView.value);
        newInView[contentObjectIndex + 1] = true;
        inView.value = newInView;
    }
}

const columns = computed<number>(() => {
    return breakpoints.value.large ? 2 : 1;
});

const contentColumns = computed<InspirationalContentViewObject[][]>(() => {
    return imagesInColumns(columns.value);
});

function imagesInColumns(columns: number) :InspirationalContentViewObject[][] {
    const result = [...Array(columns)].map(x => { return []; });
    const images = showMore.value
        ? props.contentItems
        : props.contentItems.slice(0, imageAmountThreshold);
    return images.reduce((prev, content, index) => {
        prev[index % columns].push({ index, content });
        return prev;
    }, result);
}

function toggleZoomModal(index: number) {
    selectedZoomIndex.value = index;
    zoomModalToggled.value = !zoomModalToggled.value;
}

const fullScreenImages = computed<ImageWithLinkViewObject[]>(() => {
    const convertedImages: ImageWithLinkViewObject[] = [];

    props.contentItems.filter(contentItem => !contentItem.isVideo).forEach((image: any) => {
        convertedImages.push({
            imageUrl: image.url,
            link: null,
            title: image.title,
            altText: image.altText
        });
    });

    return convertedImages;
});

function toggleShowMore() {
    if (showMore.value) {
        setTimeout(() => {
            scrollToLastImageBeforeThreshold();
        }, 10);
    } else {
        setTimeout(() => {
            scrollToFirstHiddenImage();
        }, 10);
    }
    showMore.value = !showMore.value;
}

function scrollToLastImageBeforeThreshold() {
    const imageBeforeThreshold = document.querySelector(`.${classPrefix.value}${imageAmountThreshold - 1}`);
    if (imageBeforeThreshold) {
        imageBeforeThreshold.scrollIntoView({ behavior: 'smooth' });
    }
}

function scrollToFirstHiddenImage() {
    const firstHiddenImage = document.querySelector(`.${classPrefix.value}${imageAmountThreshold}`);
    if (firstHiddenImage) {
        const rect = firstHiddenImage.getBoundingClientRect();
        if (rect.bottom < 0) {
            firstHiddenImage.scrollIntoView({ behavior: 'smooth' });
            allowView(imageAmountThreshold - 1);
        }
    }
}

function closeZoomOverlay(): void {
    zoomModalToggled.value = false;
}


return { __sfc: true,props, breakpoints, uid, zoomModalToggled, selectedZoomIndex, imageAmountThreshold, showMore, inView, classPrefix, allContentIsShown, clickAction, allowView, columns, contentColumns, imagesInColumns, toggleZoomModal, fullScreenImages, toggleShowMore, scrollToLastImageBeforeThreshold, scrollToFirstHiddenImage, closeZoomOverlay }
}

})